import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IExamPaperListResponse, IExamPaperQueryParams } from "./types";

/**
 * 시험지 목록 조회 API 함수
 * @param params 조회 파라미터
 * @returns API 응답 객체
 */
export const apiGetExamPaperList = async (
  params: IExamPaperQueryParams = {}
) => {
  const response = await apiGet<IExamPaperListResponse>("/exam_papers", params);
  return response;
};

/**
 * 시험지 목록 조회 React Query 훅
 * @param params 조회 파라미터
 * @param options 쿼리 옵션
 * @returns 쿼리 결과
 */
export const useExamPaperList = (
  params: IExamPaperQueryParams = {},
  options = {}
) => {
  return useQuery({
    queryKey: QueryKeys.examPaper.list(params),
    queryFn: () => apiGetExamPaperList(params),
    select: (response) => response.data,
    ...options,
  });
};

export default useExamPaperList;
